var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import MutualFundTransactionsTable from "@frameworks/shared-library/components/Orderbook/common/MutualFundTransactionsTable/MutualFundTransactionsTable";
import di from "@frameworks/web/components/features/BasicProfile/di/servicelocator";
import GenericSidebar from "@frameworks/shared-library/components/GenericSidebar";
import SideBarClientDetails from "@frameworks/shared-library/components/OrderBookSideBar/SideBarClientDetails";
import { EValueType, } from "@frameworks/shared-library/components/GenericDetails/GenericDetails";
import moment from "moment";
import "@frameworks/salesjourney/stylesheets/components/Features/ActivityBook/RM_Orderbook/ManagePortfolio/MutualFundOrders/Mandates/MandateSidebar/MandateSidebar.scss";
import MandateOrderSideBarBody from "./MandateOrderSideBarBody";
import MandateCalendar from "@frameworks/shared-library/components/MandateCalendar/MandateCalendar/MandateCalendar";
import { EMandateStatuses, getStatusDescriptionForMandates, } from "@frameworks/shared-library/components/OrderBookSideBar/OrderBookSidebarConstants";
import { useNavigate } from "react-router-dom";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { capitalizeFirstLetter } from "@frameworks/salesjourney/utils/genericMethods";
var currentDate = new Date();
var year = currentDate.getFullYear();
var month = currentDate.toLocaleString("en-us", { month: "short" });
var firstDateOfMonth = "01 ".concat(month, " ").concat(year);
var mandateId = "";
var clientCode = "";
var MandateOrders = function (props) {
    var _a, _b;
    var navigate = useNavigate();
    var _c = __read(useState(), 2), orderDetails = _c[0], setOrderDetails = _c[1];
    var _d = __read(useState([]), 2), genericDetailsProps = _d[0], setGenericDetailsProps = _d[1];
    var _e = __read(useState([]), 2), linkedSipData = _e[0], setLinkedSipData = _e[1];
    var _f = __read(useState(new Map()), 2), dateAmountDict = _f[0], setDateAmountDict = _f[1];
    var _g = __read(useState(false), 2), showPopup = _g[0], setShowPopup = _g[1];
    var handleTableRowClick = function (data) {
        mandateId = data.mandateId;
        clientCode = data.accCode;
        var updatedData = __assign(__assign({}, data), { accountLastFourDigits: data.bankAccNumber.split("").slice(-4).join(""), modifiedDate: data.modifiedDate
                ? moment(data.modifiedDate).format("D MMMM YYYY, h:mm:ss A")
                : null, remarks: data.remarks
                ? capitalizeFirstLetter(data.remarks)
                : getStatusDescriptionForMandates(data.dpStatus) });
        var expiryDate = moment(updatedData.endDate).format("DD MMM YYYY");
        // dpCreatedDate is only available on CUG to avoid it from breaking added condition
        var updatedDpCreatedDate = (updatedData === null || updatedData === void 0 ? void 0 : updatedData.dpCreatedDate)
            ? moment(updatedData === null || updatedData === void 0 ? void 0 : updatedData.dpCreatedDate).format("D MMM YYYY, h:mm:ss A")
            : updatedData.dpDate;
        var localGenericDetails = [
            { label: "Mandate ID", value: updatedData.mandateId, copyValue: true },
            {
                label: "Bank",
                value: "".concat(updatedData.bankName, " *").concat(updatedData.accountLastFourDigits),
            },
            {
                label: "Amount",
                value: updatedData.amount,
                valueType: EValueType.CURRENCY,
            },
            {
                label: "Placed on",
                value: updatedDpCreatedDate,
            },
        ];
        if (updatedData.dpStatus === EMandateStatuses.ACTIVE ||
            updatedData.dpStatus === EMandateStatuses.INACTIVE) {
            localGenericDetails.push({
                label: updatedData.dpStatus === EMandateStatuses.ACTIVE
                    ? "Validity"
                    : "Expired on",
                value: expiryDate,
            });
        }
        setGenericDetailsProps(localGenericDetails);
        setOrderDetails(updatedData);
        if (updatedData.dpStatus === EMandateStatuses.ACTIVE) {
            getLinkedSip();
        }
        triggerGetCalendarData(firstDateOfMonth);
        props.setOpenSB(true);
    };
    var triggerGetCalendarData = function (startDate) { return __awaiter(void 0, void 0, void 0, function () {
        var mandateCalendarPayload, resp, calendarDayAmountMap_1, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    mandateCalendarPayload = {
                        userId: clientCode,
                        stDt: startDate,
                        mandateId: mandateId,
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, di.basicProfile.mandateCalendarData(mandateCalendarPayload)];
                case 2:
                    resp = _b.sent();
                    calendarDayAmountMap_1 = new Map();
                    (_a = resp.data) === null || _a === void 0 ? void 0 : _a.mandateBalance.map(function (item) {
                        var str_date = moment(item.monthDate).format("DD MMM YYYY");
                        calendarDayAmountMap_1.set(str_date, item.balanceAmount);
                    });
                    setDateAmountDict(calendarDayAmountMap_1);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _b.sent();
                    console.log("err", err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var toggleMandateCalendar = function () {
        setShowPopup(!showPopup);
    };
    var getLinkedSip = function () { return __awaiter(void 0, void 0, void 0, function () {
        var linkedSipResp, err_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, di.basicProfile.mandateLinkedSip({
                            mandateId: mandateId,
                        })];
                case 1:
                    linkedSipResp = _b.sent();
                    setLinkedSipData(((_a = linkedSipResp === null || linkedSipResp === void 0 ? void 0 : linkedSipResp.data) === null || _a === void 0 ? void 0 : _a.linkedSips) || []);
                    return [3 /*break*/, 3];
                case 2:
                    err_2 = _b.sent();
                    console.log("err", err_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleOnClickCreateNewMandate = function () {
        props.handleOpenTOC();
    };
    var generatSidebarFooter = function () {
        switch (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.dpStatus) {
            case EMandateStatuses.ACTIVE: {
                return (React.createElement("div", { className: "d-flex justify-content-between align-items-center w-100" },
                    React.createElement(MandateCalendar, { rightIcon: showPopup ? "edel-icon-arrow-up-thin" : "edel-icon-arrow-down", toggleMandateCalendar: toggleMandateCalendar, isMandateCalendarShow: showPopup, dateAmountDict: dateAmountDict, triggerGetCalendarData: triggerGetCalendarData })));
            }
            case EMandateStatuses.REGISTRATION_FAILED: {
                return (React.createElement(EdButton, { btnTyp: "tomato-filled-rounded", onClick: handleOnClickCreateNewMandate, className: "DMSansNormal_12_400 txt_white ms-0 me-auto pt-2 pb-2 ps-5 pe-5", value: "Create New Mandate" }));
            }
        }
    };
    var handleViewDetailsClick = function (mandateIdForRow) {
        var _a;
        var rowDataForViewDetails = (_a = props === null || props === void 0 ? void 0 : props.tableData) === null || _a === void 0 ? void 0 : _a.find(function (item) {
            return item.mandateId === mandateIdForRow;
        });
        if (rowDataForViewDetails) {
            handleTableRowClick(rowDataForViewDetails);
        }
    };
    React.useEffect(function () {
        var _a, _b, _c;
        if (((_a = props === null || props === void 0 ? void 0 : props.mandateIdForViewDetails) === null || _a === void 0 ? void 0 : _a.isViewDetailsClicked) &&
            ((_b = props === null || props === void 0 ? void 0 : props.mandateIdForViewDetails) === null || _b === void 0 ? void 0 : _b.mandateId)) {
            handleViewDetailsClick((_c = props === null || props === void 0 ? void 0 : props.mandateIdForViewDetails) === null || _c === void 0 ? void 0 : _c.mandateId);
        }
    }, [(_a = props === null || props === void 0 ? void 0 : props.mandateIdForViewDetails) === null || _a === void 0 ? void 0 : _a.isViewDetailsClicked]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "primary-mandate-transactions-container ".concat((_b = props === null || props === void 0 ? void 0 : props.parentClassName) !== null && _b !== void 0 ? _b : "") },
            React.createElement(MutualFundTransactionsTable, { columns: props.tableColumns, data: props.tableData, rowOnClick: handleTableRowClick, showViewAll: props.showViewAll, viewAllOnClick: props === null || props === void 0 ? void 0 : props.viewAllOnClick, showShimmer: props === null || props === void 0 ? void 0 : props.showShimmer, selectedSortColumnVal: props === null || props === void 0 ? void 0 : props.defaultSortingColumnKey, errorScreenBtnCallback: function () { return navigate("/dashboard/product-bouquet"); }, selectedDefaultSortType: props === null || props === void 0 ? void 0 : props.selectedDefaultSortType })),
        React.createElement(GenericSidebar, { parentClassname: "primary-order-book-sidebar-container d-flex flex-column", header: React.createElement("div", { className: "order-book-sidebar-header" },
                React.createElement("span", { className: "header-text DMSansNormal_20_400 txt_white" }, "Mandate ".concat(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.bankName, " *").concat(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.accountLastFourDigits),
                    " ")), body: React.createElement(React.Fragment, null,
                React.createElement(SideBarClientDetails, { pan: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.pan, clientCode: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.accCode, clientName: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.clientName, uniqueClientId: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.uccCode, clientTier: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.clientTier, tooltipPlacement: "bottom" }),
                React.createElement(MandateOrderSideBarBody, { orderDetails: orderDetails, genericDetailsProps: genericDetailsProps, linkedSips: linkedSipData })), footer: generatSidebarFooter(), openKey: props.openSB, setOpenKey: props.setOpenSB, arrowClose: true, delay: 10 })));
};
export default MandateOrders;
